module.exports = __webpack_public_path__ + "img/validate.bc32087.png";